import React, { useEffect } from 'react'
import { ProjectProps } from '../Project'
import { FunctionModel } from '../../../utils/interfaces'
import { BoldHeader3 } from '../../../components/General'
import { useTranslation } from 'react-i18next'
import { Input } from '../../../components/Input'
import { BiTrash } from 'react-icons/bi'
import Loading from '../../../components/Loading'
import { Admin } from '../../../api/API'

interface Props extends ProjectProps {
  func: FunctionModel
  envs: { [key: string]: string }
  setEnvs: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>
}

const FunctionEnv = (props: Props) => {

  const { t } = useTranslation();
  const [envsArray, setEnvsArray] = React.useState<{ key: string, value: string }[]>([]);
  const [isSaving, setIsSaving] = React.useState(false);

  useEffect(() => {
    setEnvsArray(Object.entries(props.envs).map(([key, value]) => ({ key, value })));
  }, [props.envs]);

  const isSameEnv = () => {
    const arr = Object.entries(props.envs).map(([key, value]) => ({ key, value }));
    return arr.length === envsArray.length && arr.every(env => envsArray.find(e => e.key === env.key && e.value === env.value));
  }

  const invalidEnv = () => {
    return envsArray.some(env => !env.key) ||
      envsArray.some((env, i) => envsArray.some((env2, j) => i !== j && env.key === env2.key));  
  }

  const saveEnv = async () => {
    setIsSaving(true);
    const newEnv = Object.fromEntries(envsArray.map(env => [env.key, env.value]));
    await Admin.setFunctionEnvs(props.project.id, props.func.id, newEnv);
    props.setEnvs(newEnv);
    setIsSaving(false);
  }

  return (
    <>
      <div className='max-w-3xl'>
        <BoldHeader3>{t('project.function.env')}</BoldHeader3>
        <div className='my-4'>
          <div className='flex flex-col gap-2'>
            {envsArray.map((env, i) => (
              <div className='flex items-center'>
                <Input textSize='small' style={{ maxWidth: '320px' }} value={env.key} onChange={e => setEnvsArray([...envsArray.slice(0, i), { key: e.target.value, value: env.value }, ...envsArray.slice(i + 1)])} />
                <span className='mx-2'>:</span>
                <Input textSize='small' style={{ maxWidth: '320px' }} value={env.value} onChange={e => setEnvsArray([...envsArray.slice(0, i), { key: env.key, value: e.target.value }, ...envsArray.slice(i + 1)])} />
                <button onClick={() => setEnvsArray([...envsArray.slice(0, i), ...envsArray.slice(i + 1)])} className='flex items-center justify-center w-6 h-8 text-gray-400 ml-2'><BiTrash /></button>
              </div>
            ))}
            <div>
              <button onClick={() => setEnvsArray([...envsArray, { key: '', value: '' }])} className='text-xs bg-gray-100 px-6 py-1.5 rounded-lg'>{t('general.add')}</button>
            </div>
            <div className='mt-4'>
              <button disabled={isSaving || isSameEnv() || invalidEnv()} onClick={saveEnv} className='text-xs text-white bg-primary disabled:bg-gray-300 flex items-center justify-center px-6 h-7 rounded-lg'>{isSaving ? <Loading /> : t('general.save')}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FunctionEnv